import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCompanyCategory from '../useCompanyCategory';

const SingleCompanyCategory = () => {
  const { t } = useTranslation();
  const { singleData, loading } = useCompanyCategory(false);
  const [searchParams] = useSearchParams();

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const dataKeys = [
    { key: 'title', text: t('Titolo') },
    { key: 'nego_tov_id', text: t('NEGO ID (TOV)') },
    { key: 'nego_sov_id', text: t('NEGO ID (SOV)') },
    { key: 'nego_rov_id', text: t('NEGO ID (ROV)') },
    { key: 'commercial_name', text: t('Nome commerciale') },
  ];

  const title = isSuccessUpdatePage
    ? t('COMPANY CATEGORY WAS SUCCESSFULLY UPDATED.')
    : t('COMPANY CATEGORY');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <List
            header={<div>{t('COMPANY CATEGORY')}</div>}
            dataSource={dataKeys}
            renderItem={(item) => (
              <List.Item>
                <b className={styles.itemName}>{item.text}</b>
                {singleData?.[item.key]}
              </List.Item>
            )}
          />
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/company_categories/${singleData?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/company_categories'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleCompanyCategory;
